import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Loading.vue'

Vue.use(VueRouter)

const routes = [
  // Base routes
  {
    path: '/',
    name: 'Loading',
    component: Home
  },
  {
    path: '/forms-of-payment-server-side',
    name: 'Forms Of Payment Server Side',
    meta: { title: 'Forms Of Payment Server Side', isAppBarExtended: true },
    component: () => import('../views/forms-of-payment-server-side.vue')
  },

  // Application routes
  {
    path: '/stream',
    name: 'Stream',
    meta: { isAppBarExtended: true },
    component: () => import('../views/stream.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    meta: { isAppBarExtended: true },
    component: () => import('../views/dashboard.vue')
  },
  {
    path: '/bookings2',
    name: 'Calendar',
    meta: { isAppBarExtended: true },
    component: () => import('../views/bookings2.vue')
  },
  {
    path: '/items',
    name: 'Items',
    meta: { isAppBarExtended: true },
    component: () => import('../views/items.vue')
  },
  {
    path: '/categories',
    name: 'Categories',
    meta: { isAppBarExtended: true },
    component: () => import('../views/categories.vue')
  },
  {
    path: '/customers',
    name: 'Customers',
    meta: { isAppBarExtended: true },
    component: () => import('../views/customers.vue')
  },
  {
    path: '/customers/:uuid',
    name: 'Customer',
    meta: { isAppBarExtended: true },
    component: () => import('../views/customers/uuid.vue')
  },
  {
    path: '/staff',
    name: 'Staff',
    meta: { isAppBarExtended: true },
    component: () => import('../views/staff.vue')
  },
  {
    path: '/staff/:uuid',
    name: 'Staff Member',
    meta: { isAppBarExtended: true },
    component: () => import('../views/staff/uuid.vue')
  },
  {
    path: '/sales',
    name: 'Sales',
    meta: { isAppBarExtended: true },
    component: () => import('../views/sales/invoices.vue')
  },
  {
    path: '/sales/invoices',
    name: 'Invoices',
    meta: { isAppBarExtended: true },
    component: () => import('../views/sales/invoices.vue')
  },
  {
    path: '/sales/orders',
    name: 'Orders',
    meta: { isAppBarExtended: true },
    component: () => import('../views/sales/orders.vue')
  },
  {
    path: '/sales/orders/:uuid',
    name: 'Order',
    meta: { isAppBarExtended: true },
    component: () => import('../views/sales/orders/uuid.vue')
  },
  {
    path: '/sales/estimates',
    name: 'Estimates',
    meta: { isAppBarExtended: true },
    component: () => import('../views/sales/estimates.vue')
  },
  {
    path: '/sales/eodReport',
    name: 'End of Day Report',
    meta: { isAppBarExtended: true },
    component: () => import('../views/sales/eodReport.vue')
  },
  {
    path: '/sales/tasks',
    name: 'Tasks',
    meta: { isAppBarExtended: true },
    component: () => import('../views/sales/tasks.vue')
  },
  {
    path: '/payments',
    name: 'Payments',
    meta: { isAppBarExtended: true },
    component: () => import('../views/payments.vue')
  },
  {
    path: '/reports',
    name: 'Reports',
    meta: { isAppBarExtended: true },
    component: () => import('../views/reports.vue')
  },
  {
    path: '/forms-of-payment',
    name: 'Forms of Payment',
    meta: { isAppBarExtended: true },
    component: () => import('../views/forms-of-payment.vue')
  },
  {
    path: '/point-cards',
    name: 'Point Cards',
    meta: { isAppBarExtended: true },
    component: () => import('../views/point-cards.vue')
  },
  {
    path: '/subscriptions',
    name: 'Subscriptions',
    meta: { isAppBarExtended: true },
    component: () => import('../views/subscriptions.vue')
  },
  {
    path: '/store',
    name: 'Store',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store.vue')
  },
  {
    path: '/store/locations',
    name: 'Locations',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/locations.vue')
  },
  {
    path: '/store/locations/:uuid',
    name: 'Location',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/locations/uuid.vue')
  },
  {
    path: '/store/locations/:uuid/edit',
    name: 'Edit Location',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/locations/uuid/edit.vue')
  },
  {
    path: '/store/locations/:uuid/qr-print',
    name: 'QR Print',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/locations/uuid/qr-print.vue')
  },
  {
    path: '/store/locations/:location_uuid/zones/:uuid',
    name: 'Tables',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/locations/location_uuid/zones/uuid.vue')
  },
  {
    path: '/store/locations/:location_uuid/combinations',
    name: 'Combinations',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/locations/location_uuid/combinations.vue')
  },
  {
    path: '/store/discounts',
    name: 'Discounts',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/discounts.vue')
  },
  {
    path: '/store/items',
    name: 'Store Items',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/items.vue')
  },
  {
    path: '/store/items/:uuid',
    name: 'Store Item',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/items/uuid.vue')
  },
  {
    path: '/store/items/:uuid/bookings',
    name: 'Bookings on Event',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/items/uuid/bookings.vue')
  },
  {
    path: '/store/bulk-edit',
    name: 'Bulk Edit',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/bulk-edit.vue')
  },
  {
    path: '/store/categories',
    name: 'Store Categories',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/categories.vue')
  },
  {
    path: '/store/categories/:uuid',
    name: 'Store Category',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/categories/uuid.vue')
  },
  {
    path: '/store/coupons',
    name: 'Store Coupons',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/coupons.vue')
  },
  {
    path: '/store/coupons/:uuid',
    name: 'Coupon',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/coupons/uuid.vue')
  },
  {
    path: '/store/taxes',
    name: 'Taxes',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/taxes.vue')
  },
  {
    path: '/store/delivery-services',
    name: 'Delivery Services',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/delivery-services.vue')
  },
  {
    path: '/store/sorting',
    name: 'Sorting',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store/sorting.vue')
  },
  {
    path: '/coupons',
    name: 'Coupons',
    meta: { isAppBarExtended: true },
    component: () => import('../views/coupons.vue')
  },
  {
    path: '/bookings',
    name: 'Bookings Old',
    meta: { isAppBarExtended: true },
    component: () => import('../views/bookings.vue')
  },
  {
    path: '/bookings/:uuid',
    name: 'Booking',
    meta: { isAppBarExtended: true },
    component: () => import('../views/bookings/uuid.vue')
  },
  {
    path: '/work',
    name: 'Work',
    meta: { isAppBarExtended: true },
    component: () => import('../views/work.vue')
  },
  {
    path: '/users',
    name: 'Users',
    meta: { isAppBarExtended: true },
    component: () => import('../views/users.vue')
  },
  {
    path: '/users/:uuid',
    name: 'User',
    meta: { isAppBarExtended: true },
    component: () => import('../views/users/uuid.vue')
  },
  {
    path: '/account',
    name: 'Account',
    meta: { isAppBarExtended: true, type: 'nativeHidden' },
    component: () => import('../views/account.vue')
  },
  {
    path: '/team',
    name: 'Team',
    meta: { isAppBarExtended: true },
    component: () => import('../views/team.vue')
  },
  {
    path: '/company',
    redirect: '/company/settings'
  },
  {
    path: '/company/devices',
    name: 'Devices',
    meta: { isAppBarExtended: true },
    component: () => import('../views/company/devices.vue')
  },
  {
    path: '/company/organizations',
    name: 'Organizations',
    meta: { isAppBarExtended: true },
    component: () => import('../views/company/organizations.vue')
  },
  {
    path: '/company/channels',
    name: 'Channels',
    meta: { isAppBarExtended: true },
    component: () => import('../views/company/channels.vue')
  },
  {
    path: '/company/channels/:uuid',
    name: 'Channel',
    meta: { isAppBarExtended: true },
    component: () => import('../views/company/channels/uuid.vue')
  },
  {
    path: '/company/settings',
    name: 'Settings',
    meta: { isAppBarExtended: true },
    component: () => import('../views/company/settings.vue')
  },
  {
    path: '/company/messages',
    name: 'Messages',
    meta: { isAppBarExtended: true },
    component: () => import('../views/company/messages.vue')
  },
  {
    path: '/billing',
    name: 'Billing',
    meta: { isAppBarExtended: true },
    component: () => import('../views/billing.vue')
  },
  {
    path: '/billing/invoices',
    name: 'Billing Invoices',
    meta: { isAppBarExtended: true },
    component: () => import('../views/billing/invoices.vue')
  },
  {
    path: '/translations',
    name: 'Translations',
    meta: { isAppBarExtended: true },
    component: () => import('../views/translations.vue')
  },
  {
    path: '/process-display-systems',
    name: 'Process Display Systems',
    meta: { isAppBarExtended: true },
    component: () => import('../views/process-display-systems.vue')
  },
  {
    path: '/order-status-displays',
    name: 'Order Status Display Systems',
    meta: { isAppBarExtended: true },
    component: () => import('../views/order-status-displays.vue')
  },
  {
    path: '/store-widgets',
    name: 'Store Widgets',
    meta: { isAppBarExtended: true },
    component: () => import('../views/store-widgets.vue')
  },
  {
    path: '/schedule-widgets',
    name: 'Schedule Widgets',
    meta: { isAppBarExtended: true },
    component: () => import('../views/schedule-widgets.vue')
  },
  {
    path: '/kiosks',
    name: 'Kiosks',
    meta: { isAppBarExtended: true },
    component: () => import('../views/kiosks.vue')
  },
  {
    path: '/integrations',
    name: 'Integrations',
    meta: { isAppBarExtended: true },
    component: () => import('../views/integrations.vue')
  },
  {
    path: '/printers',
    name: 'Printers',
    meta: { isAppBarExtended: true },
    component: () => import('../views/printers.vue')
  },
  {
    path: '/templates',
    name: 'Templates',
    meta: { isAppBarExtended: true },
    component: () => import('../views/templates.vue')
  },
  {
    path: '/upsell-groups',
    name: 'Upsell Groups',
    meta: { isAppBarExtended: true },
    component: () => import('../views/upsell-groups.vue')
  },

  // Catch-all
  {
    path: '*',
    redirect: '/dashboard'
  }
]

let routerMode = 'hash'

if (
  window.location.host === 'app.salescloud.is' ||
  window.location.host === 'localhost:3000'
) {
  routerMode = 'history'
}

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: routerMode,
  routes
})

const originalPush = router.push
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (err && err.name === 'NavigationDuplicated') return err
    throw err
  })
}

const originalReplace = router.replace
router.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => {
    if (err && err.name === 'NavigationDuplicated') return err
    throw err
  })
}

export default router
